import { Field } from 'formik';
import React from 'react';
import SelectField, { ISelectFieldProps } from './SelectField';
import { withFormik } from './withFormik/withSelectFormik';

interface IFormikSelectFieldProps {
	name: string;
	// eslint-disable-next-line react/require-default-props
	required?: boolean;
	// eslint-disable-next-line react/require-default-props
	label?: string;
}

type IFormikControlMethods = {
	onConditionChange?: (val: string) => void;
};

type FormikSelectProps = ISelectFieldProps &
	IFormikSelectFieldProps &
	IFormikControlMethods;

const selectWithFormik = withFormik(SelectField);

const FormikSelectField: React.FC<
	FormikSelectProps & Partial<ISelectFieldProps>
> = ({ name, ...rest }) => (
	<Field name={name} component={selectWithFormik} {...rest} />
);

FormikSelectField.defaultProps = {
	onConditionChange: () => {}
};

export default FormikSelectField;
